import React from 'react';
import { JuniorLayout } from '../../components/layout/JuniorLayout';
import { ActivityShell } from '../../components/activity/ActivityShell';
import { RequireJuniorSession } from '../../components/auth/RequireJuniorSession';
import { BoomJuniorShell } from '../../components/boom/BoomJuniorShell';
import { MelodyApp } from '../../boom/apps/MelodyApp';
import { useJuniorAliveNav } from '../../contexts/JuniorAliveNavContext';
import {
  PresentationModeProvider,
  usePresentationMode,
} from '../../contexts/PresentationModeContext';

function BoomPatronesPageInner() {
  const { navigateAlive } = useJuniorAliveNav();
  const { isPresentation } = usePresentationMode();

  return (
    <JuniorLayout immersive presentation={isPresentation}>
      <ActivityShell
        title="Boom Patrones"
        subtitle="Patrones de color con boomwhackers"
        backTo="/melodia"
        backLabel="Melodía"
        immersive
        lockViewport
        fullBleed
        presentation={isPresentation}
      >
        <BoomJuniorShell>
          <MelodyApp onBack={() => navigateAlive('/melodia')} />
        </BoomJuniorShell>
      </ActivityShell>
    </JuniorLayout>
  );
}

export default function BoomPatronesPage() {
  return (
    <RequireJuniorSession>
      <PresentationModeProvider>
        <BoomPatronesPageInner />
      </PresentationModeProvider>
    </RequireJuniorSession>
  );
}
